// extracted by mini-css-extract-plugin
module.exports = {"namesContainer":"_1iXF9","loaderContainer":"s8878"};